import { BaseBuildTableData } from '../FilterResultsManager/types';
import { Box } from '@lifeomic/chroma-react/components/Box';
import { Divider } from '@lifeomic/chroma-react/components/Divider';
import { Paper } from '@lifeomic/chroma-react/components/Paper';
import { defineMessages, useIntl } from 'react-intl';
import { sharedMessages } from '../sharedIntlLabels';
import { Text } from '@lifeomic/chroma-react/components/Text';
import { Zap } from '@lifeomic/chromicons';
import { useSharedDetailsStyles } from './sharedDetailsStyles';
import {
  getCKB,
  getGene,
  getEffect,
  getPosition,
  getCopyNumber,
  getLabReportedSignificance,
} from '../FilterResultsManager/CopyNumberVariantsContent/buildTableData';
import * as React from 'react';
import clsx from 'clsx';

const messages = defineMessages({
  summary: {
    id: 'omicsExplorer.variantDetails.dialog.variantDetails.copyNumberDetails.summary',
    defaultMessage: 'Summary',
  },
});

interface CopyNumberDetailsProps
  extends Omit<BaseBuildTableData, 'formatMessage' | 'onSort'> {
  variant?: unknown;
}

export const CopyNumberDetails: React.FC<CopyNumberDetailsProps> = ({
  build,
  variant,
}) => {
  const classes = useSharedDetailsStyles({});

  const { formatMessage } = useIntl();

  return (
    <Box direction="column">
      <Paper className={clsx(classes.paper, classes.oneCol)}>
        <Box className={classes.subhead}>
          <Zap className={classes.icon} />
          <Text weight="bold">{formatMessage(messages.summary)}</Text>
        </Box>
        <dl>
          <dt>{formatMessage(sharedMessages.jax)}</dt>
          <dd>{getCKB(variant)}</dd>
          <Divider className={classes.divider} />
          <dt>{formatMessage(sharedMessages.gene)}</dt>
          <dd>{getGene(variant)}</dd>
          <Divider className={classes.divider} />
          <dt>{formatMessage(sharedMessages.effect)}</dt>
          <dd>{getEffect(variant)}</dd>
          <Divider className={classes.divider} />
          <dt>{formatMessage(sharedMessages.position)}</dt>
          <dd>{getPosition({ build, value: variant })}</dd>
          <Divider className={classes.divider} />
          <dt>{formatMessage(sharedMessages.copyNumber)}</dt>
          <dd>{getCopyNumber(variant)}</dd>
          <Divider className={classes.divider} />
          <dt>{formatMessage(sharedMessages.labReportedSignificance)}</dt>
          <dd>{getLabReportedSignificance(variant)}</dd>
        </dl>
      </Paper>
    </Box>
  );
};
